import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import * as S from './DashboardWarning.styles';
export const DashboardWarning = ({
  hidden,
  title,
  redirect,
  onClose,
  onClick,
  children
}) => {
  const {
    push,
    prefetch
  } = useRouter();
  useEffect(() => {
    redirect && prefetch(redirect.to);
  }, []);
  if (hidden) return null;
  return /*#__PURE__*/React.createElement(S.Root, {
    oneLine: !children,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(S.WarningTitle, null, title), /*#__PURE__*/React.createElement(S.WarningMessage, null, children, redirect && /*#__PURE__*/React.createElement(S.Link, {
    onClick: e => {
      if (onClick) {
        return onClick(e);
      }
      push(redirect?.to);
    }
  }, redirect?.label.split(' ').join('\xa0'))));
};